export const myWallet = "My wallet" as const;
